/**
 * @author: lv.chen
 * @desc: AppstoreRankDetailsModal浮窗
 * @date: 2025/12/15
 */
import React from 'react';
import classnames from 'classnames';
import { useQueryDefinition } from '@intelligence/hooks/useQueryDefinition';
import { getCountryFlag } from '@home/_config/countries';
import { getDodClassName } from '../../utils';

interface IAppstoreRankDetailsModalProps extends IBaseProps {
  data?: IMarketRankItem[] | null;
}

const AppstoreRankDetailsModal: React.FC<IAppstoreRankDetailsModalProps> = (props) => {
  const { style, className, data } = props;

  const countryMapNew = useQueryDefinition('countryMapNew', {});

  const getCountryName = (marketCode: string) => {
    const countryInfo = countryMapNew[marketCode];
    return countryInfo?.country_name_cn || countryInfo?.country_name_en || marketCode?.toUpperCase();
  };

  const renderTrend = (rankDod: number | null) => {
    if (rankDod === null || rankDod === undefined) {
      return null;
    }
    if (rankDod === 0) {
      return <div className="dbi-rank-trend-num dbi--equal"></div>;
    }
    return (
      <div className={classnames('dbi-rank-trend-num', getDodClassName(rankDod))}>
        <span>{Math.abs(rankDod)}</span>
      </div>
    );
  };

  if (!data?.length) {
    return null;
  }
  return (
    <div
      style={style}
      className={classnames('dbi-casual-daily-reports-appstore-rank-details-modal dbi-game-rank-hovertips', className)}
    >
      <div className="dbi-game-rank-box">
        <div className="dbi-game-rank-box-title">上榜前十国家详情</div>
        <div className="dbi-game-rank">
          <div className="dbi-rank-country-list">
            {data?.map((item, index) => {
              const itemMarket = item?.market || '';
              const itemMarketStd = itemMarket?.toLowerCase() || '';
              return (
                <div key={`${itemMarket}-${index}`} className="dbi-rank-country-item">
                  <div className="dbi-rank-country-item-img">
                    <img src={getCountryFlag(itemMarketStd)} alt={itemMarketStd} />
                  </div>
                  <div className="dbi-rank-country-item-name">{getCountryName(itemMarketStd)}</div>
                  <div className="dbi-rank-country-item-num">#{item?.rank}</div>
                  <div className="dbi-rank-country-item-trend">{renderTrend(item?.rank_dod)}</div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AppstoreRankDetailsModal;
